import React from "react";
import PropTypes from "prop-types";
//Material imports
import MUIFab from "@material-ui/core/Fab";
import Fade from "@material-ui/core/Fade";
//Limitless imports
import { useAppVisibilityContext } from "hooks/app-visibility/AppVisibilityContext";

const ExpandableFab = ({ classes, isMobileDevice, onClick, fabText, CloseIcon, openIcon, ...rest }) => {
    const [showText, setShowText] = React.useState(isMobileDevice);

    const {
        appVisibility: { isAppOpen }
    } = useAppVisibilityContext();

    React.useEffect(() => {
        if (isAppOpen) {
            setShowText(isMobileDevice);
        }
    }, [isAppOpen]);

    const handleClick = () => {
        onClick();
        if (isAppOpen) {
            setShowText(true);
        }
    };

    const handleMouseLeave = () => {
        if (!isAppOpen) {
            setShowText(false);
        }
    };

    const handleMouseEnter = () => {
        if (!isAppOpen) {
            setShowText(true);
        }
    };

    const expandedStyles = {};
    if (showText) {
        expandedStyles.height = 48;
        expandedStyles.borderRadius = 20;
    }

    const OpenIcon = openIcon;

    return (
        <MUIFab
            variant={!showText ? "round" : "extended"}
            size="medium"
            className={`${classes.button} ${isMobileDevice && isAppOpen ? classes.hidden : ""} ${
                !showText ? classes.iconButton : ""
            }`}
            {...rest}
            onClick={handleClick}
            style={expandedStyles}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            classes={{ root: classes.fabRoot }}
        >
            {!showText && <Fade in>{isAppOpen ? <CloseIcon /> : OpenIcon}</Fade>}
            {showText && <span className={classes.fabText}>{fabText}</span>}
        </MUIFab>
    );
};

export default ExpandableFab;

ExpandableFab.propTypes = {
    classes: PropTypes.object.isRequired,
    isMobileDevice: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    fabText: PropTypes.string.isRequired,
    openIcon: PropTypes.object.isRequired,
    CloseIcon: PropTypes.object.isRequired
};
